import { Box, Centralizer, Loading } from '@/components';
import { TenantManagerResourceGuard } from '@/features/authentication/_components/TenantManagerResourceGuard';
import { useId } from '@/hooks';
import { useMessage } from '@/providers';
import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBulkRole, useRole } from '../../hooks';
import { BulkRoleFormModal } from './BulkRoleFormModal';
import { RoleDetails } from './RoleDetails';

export const RoleDetailsPage: FC = () => {
  const { t } = useTranslation();
  const { openMessage } = useMessage();
  const { id } = useId();
  const [openModal, setOpenModal] = useState(false);
  const role = useRole(id);
  const { mutateAsync: bulkRoleAsync } = useBulkRole();

  if (role.isLoading || !role.data) {
    return <Loading />;
  }

  return (
    <>
      <Centralizer>
        <RoleDetails role={role.data} />
        <TenantManagerResourceGuard onlyEdit>
          <Box marginTop={16}>
            {/* <Button
              type="default"
              onClick={() => {
                setOpenModal(true);
              }}
            >
              {t('title-bulk-role')}
            </Button> */}
          </Box>
        </TenantManagerResourceGuard>
      </Centralizer>

      <BulkRoleFormModal
        open={openModal}
        onSubmit={async (values) => {
          await bulkRoleAsync({ id, ...values });
          await Promise.all([
            openMessage('success', t('message-update-completed')),
            (async () => {
              setOpenModal(false);
            })(),
          ]);
        }}
        onCancel={() => {
          setOpenModal(false);
        }}
      />
    </>
  );
};
